import type { ChatEmailSecretRoute } from "@/app/api/user/chat-email-secret/route";
import { getJson } from "@/utils/routeUtils";
import { queryOptions } from "@tanstack/react-query";

export const chatEmailSecretOptions = ({
  enabled = true,
}: { enabled?: boolean } = {}) =>
  queryOptions({
    queryKey: ["chat-email-secret"] as const,
    queryFn: async (): Promise<ChatEmailSecretRoute["output"]> => {
      const { data, error } = await getJson("/api/user/chat-email-secret", {});
      if (error || !data) return { chatEmailSecret: null };
      return data;
    },
    enabled,
  });
